import '../../screens/info/Info.scss'

const InfoBoxes = ({ image, title, action, color }) => (
  <button
    type="button"
    className="Info__box"
    onClick={action}
    style={{backgroundColor: color }}
    aria-label={`Más información sobre ${title}`} // Mejora de accesibilidad
  >
    <div className="Info__box__image">
      <img src={image} alt="icon" />
    </div>
    <div className="Info__box__title">
      <h2>{title}</h2>
    </div>
    <div className="Info__box__arrow">
      <img src="/misc/icons/arrow-right-pink.svg" />
    </div>
  </button>
);

export default InfoBoxes